<template>
	<div class="tab-box">
		<van-tabs @click="switchTab" v-model="active">
			<slot name="left"></slot>
			<van-tab :title="tab.formName" :key="tab.uuid" v-for="tab in tabList">
				<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
					<van-search shape="round" v-model="value" placeholder="请输入搜索关键词" show-action @search="onSearch" @cancel="onSearch">
						<div slot="action" @click="onSearch">搜索</div>
					</van-search>
					<!--  -->
					<div id="newBtn" v-if="isShowAddBtn && (userId === advisorId ||
					checkPermission(tab.workflowTemplateId) !== -1)"><span style="font-size: 50px;" class="icon iconfont icon-jiahao-o" @click="(tab.workflowTemplateId && tab.workflowTemplateId != '')?openForm('0',tab.workflowTemplateId):openTabDetails('0')"></span></div>
					<van-list v-model="loading" :finished="finished" @load="onLoad" finished-text="没有更多了">
						<div v-for="form in list" class="card" :key="form.uuid" @click.stop="(tab.workflowTemplateId && tab.workflowTemplateId != '')?openForm(form.uuid,form.workflowTemplateId):openTabDetails(form.uuid)">
							<table class="layout">
								<tr>
									<td class="avatar-box" rowspan="4">
										<img :src="avatarUrl + form.creatorIdavatar" class="avatar" alt="avatar">
										<p class="advisor">{{form.creatorIdname}}</p>
									</td>
									<td colspan="2">
										<div class="header">
											<span class="title">{{form.name}}</span>
										</div>
									</td>
								</tr>
								<tr>
									<td colspan="2" class="content">
										 <p v-for="field in displayField" :key="field.fieldName">
										    <span :class="icon + field.appIcon"></span>
										    <span>{{form[field.dictionary ? field.fieldName+'name':field.fieldName] || '无'}}</span>
										</p>
									</td>
								</tr>
								<tr>
								    <td>
								        <span style="margin-left:0;"
								              v-if="tab.tableName=== 'crm_project_contract'"
								              class="icon iconfont icon-shoukuan"
								              @click.stop="addReceipt(form.uuid)"></span>
								    </td>
								</tr>
							</table>
						</div>
					</van-list>
				</van-pull-refresh>
			</van-tab>
		</van-tabs>
	</div>
</template>

<script>
	import {
		NavBar,
		Button,
		Toast,
		Icon,
		Dialog,
		Tab,
		Tabs,
		List,
		PullRefresh,
		Popup,
		Search
	} from 'vant';
	import moment from "moment";
	import userInfo from '../store/userInfo';
	import saleChanceService from "../service/saleChanceService";
	import fieldDescriptionService from "../service/fieldDescriptionService";
	import {
		formatDictionary
	} from "../utils/dictionary";
	import {
		API_URL
	} from "../common/config";

	export default {
		data: function() {
			return {
				active:0,
				selected: 0,
				tabList: [],
				list: [],
				loading: false,
				finished: false,
				pageIndex: 0,
				tab: null,
				value: "",
				refreshing: false,
				defaultValue: {},
				dictionaryNames: '',
				displayField: [],
				// isShowAddBtn: false
			}
		},
		props: {
			id: {
				type: String,
				default: ''
			},
			host: {
				type: String,
				default: ''
			},
			advisorId: {
				type: String,
				default: ''
			},
			slotCount:  {
				type: Number,
				default: 0
			},
		},
		components: {
			[NavBar.name]: NavBar,
			[Button.name]: Button,
			[Icon.name]: Icon,
			[Dialog.name]: Dialog,
			[Tab.name]: Tab,
			[Tabs.name]: Tabs,
			[List.name]: List,
			[PullRefresh.name]: PullRefresh,
			[Popup.name]: Popup,
			[Search.name]: Search,
		},
		computed: {
			userId() {
				return this.$store.getters.getUserId;
			},
			departmentId() {
				return this.$store.getters.getDepartmentId;
			},
			avatarUrl() {
				return API_URL + "/oa/common/attachment/showImage?id=";
			},
			icon() {
			    return "iconfont ";
			},
			isShowAddBtn() {
				return this.tab.createFrom && this.tab.createFrom.indexOf("host") !== -1 && this.tab.isCreatable
			}
		},
		mounted: async function() {
			let resp = await saleChanceService.getTab(this.id, this.host);
			if (resp.data.Status == "1") {
				let hash = {};
			
				this.tabList = resp.data.Data.reduce(function(item, next) {
					if (hash[next['tableName']]) {
						$.each(item, function(x, y) {
							if (y.tableName === next.tableName) {
								y.host = y.host + "," + next.host;
							}
						})
					} else {
						hash[next['tableName']] = next.tableName;
						item.push(next);
					}
					return item;
				}, []);
				let tabIndex = localStorage.getItem(this.host + 'tabIndex');
				if(tabIndex === undefined || tabIndex === null) {
					tabIndex = 0;
					this.active = 0;
				}else {
					this.active = parseInt(tabIndex);
				}
				let index = parseInt(tabIndex) - parseInt(this.slotCount);
				if (index >= 0) {
					this.tab = this.tabList[index];
				}else {
					this.tab = this.tabList[0];
				}
				
					let displayField = await fieldDescriptionService.getFieldDisplayOnAPP(this.tab.tableName);
				if (displayField.data.Status === "1") {
					this.displayField = displayField.data.Data;
				}
			}

		},
		methods: {
			async onLoad() {
				 let displayField = await fieldDescriptionService.getDictionaryName(this.tab.tableName);
					if (displayField.data.Status === "1") {
						this.dictionaryNames = displayField.data.Data;
						this.pageIndex++;
						let resp = await saleChanceService.getFormDataList(this.pageIndex, this.id, this.value, this.tab.tableName, this.host +
							'Id',this.dictionaryNames);
						resp.data.Data.data.forEach(form => {
							form.createTime = moment(form.createTime).format('YYYY-MM-DD');
						});
						formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
						this.loading = false;
						this.refreshing = false;
						this.list = [...this.list, ...resp.data.Data.data];
						this.finished = resp.data.Data.total <= this.list.length;
						
						let result = await saleChanceService.getFormParameter(this.tab.uuid, '', this.id, '');
						if (result.data.Status === "1") {
							let defaultValue = {};
							if (this.tab.workflowTemplateId && this.tab.workflowTemplateId != '') {
								defaultValue = {
									advisorId: this.advisorId
								};
							} else {
								defaultValue = {
									advisorId: this.advisorId,
									createTime: moment(new Date()).format('YYYY-MM-DD HH:mm'),
									creatorId: this.userId
								};
						
							}
							let hostId = this.host + 'Id';
							defaultValue[hostId] = this.id;
							var pairs = result.data.Data.split('&');
							for (var i = 0; i < pairs.length; i++) {
								var pair = pairs[i];
								if (pair) {
									var split = pair.split('=');
									if (split.length == 2) {
										defaultValue[split[0]] = split[1]
									}
								}
							}
							this.defaultValue = defaultValue;
						
						}
					}
			},
			onRefresh() {
				this.finished = false;
				this.pageIndex = 0;
				this.list = [];
				this.onLoad();
			},
			async switchTab(index) {
				localStorage.setItem(this.host +"tabIndex", index);
				var index = parseInt(index) - parseInt(this.slotCount);
				window.scrollTo(0, 0);
				if(index >= 0) {
					this.tab = this.tabList[index];
					let displayField = await fieldDescriptionService.getFieldDisplayOnAPP(this.tab.tableName);
					if (displayField.data.Status === "1") {
						this.displayField = displayField.data.Data;
					}
					this.onSearch();
				}
				
			},
			onSearch() {
				this.finished = false;
				this.loading = true;
				this.pageIndex = 0;
				this.list = [];
				this.onLoad();
			},
			/**
			 * 打开表单详情
			 */
			openTabDetails(id) {
				if(id == '0' && this.tab.tableName == 'crm_project_contract') {
					this.defaultValue.departmentId = this.departmentId;
				}
				this.$router.push({
					path: "TabDetails",
					query: {
						uuid: id,
						tableName: this.tab.tableName,
						id: this.id,
						hostId: this.host + 'Id',
						defaultValue: JSON.stringify(this.defaultValue)
					}
				})

			},
			addReceipt(contractId) {
				this.defaultValue.contractId = contractId;
				this.$router.push({
					path: "TabDetails",
					query: {
						uuid: '0',
						tableName: 'crm_project_receipt',
						id: this.id,
						hostId: this.host + 'Id',
						defaultValue: JSON.stringify(this.defaultValue)
					}
				})
			},
			openForm(id, workflowTemplateId) {
				this.defaultValue.formName = this.tab.formName;
				this.$router.push("/app/form/" + workflowTemplateId + "/" + id + "/" + JSON.stringify(this.defaultValue));
			},

		}
	};
</script>
<style scoped>
	#newBtn {
		position: fixed;
		right: 20px;
		bottom: 30px;
		z-index: 9999;
	}
</style>
